<template>
  <ul class="contents-jion">
    <h3 class="title-text">加盟合作</h3>
      <!--<li>-->
          <!--<span>企业邮箱:</span>-->
          <!--<p>devops@tintinhealth.com</p>-->
      <!--</li>-->

      <li>
          <span>{{$t("contact.tab1_address_label_1")}}</span>
          <p>{{$t("contact.tab1_address_1")}}</p>
      </li>
      <li>
          <span>{{$t("contact.tab1_address_label_2")}}</span>
          <p>18601311912</p>
      </li>
      <li>
          <span>{{$t("contact.tab1_address_label_3")}}</span>
          <p>{{$t("contact.tab1_address_3")}}</p>
      </li>
      <li>
          <span>{{$t("contact.tab1_address_label_4")}}</span>
          <p>010-56431371/18601311912</p>
      </li>
      <li>
          <span>{{$t("contact.tab1_address_label_5")}}</span>
          <p>{{$t("contact.tab1_address_5")}}</p>
      </li>
      <li>
          <span>{{$t("contact.tab1_address_label_6")}}</span>
          <p>19902344858</p>
      </li>
      <li>
          <span>{{$t("contact.tab1_address_label_7")}}</span>
          <p>{{$t("contact.tab1_address_7")}}</p>
      </li>
      <li>
          <span>{{$t("contact.tab1_address_label_1")}}</span>
          <p>13389657597</p>
      </li>
  </ul>
</template>

<script>
    export default {
        name: '',
        data () {
            return {}
        }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>



// WEBPACK FOOTER //
// league_cooperation.vue?4eb388f5